// extracted by mini-css-extract-plugin
export var animationContainer = "_nx-0";
export var footer = "_nx-1";
export var gray = "_nx-2";
export var lineItem = "_nx-3";
export var lineItemImage = "_nx-4";
export var lineItemInfo = "_nx-5";
export var lineItemText = "_nx-6";
export var lineItems = "_nx-7";
export var modalContent = "_nx-8";
export var options = "_nx-9";
export var orderName = "_nx-a";
export var refundAmount = "_nx-b";